export default __webpack_public_path__ + "static/media/Heading.26dda1f8.svg";